// removed by extract-text-webpack-plugin
module.exports = {"accordeon":"_3WeMrVeqy8tbzEB9yyK-72","accordionBorder":"QDerao6dBd-U6LEkuV53Y","title":"_2izQQycoBqwoOVRwxY1tK-","multitab":"_28eLZurs2_WHPIcvjCrvUh","triangleRight":"_3fO3oxJqXIcEqoCImRtJUr","triangleDown":"_1c4S8ouE3bqX3CvV2RJXgK","subTab":"_2nn0nPkGda-dMCf4fwBRPQ","headerPadding":"rU9vIWuUFB5K2WzY6GfD7","tab":"bPTClZcxhrO1Y8opVESBn","closed":"_1CN7saowaz4u4kxbk9qkMK"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/matchday/css/accordion.css
// module id = 344
// module chunks = 0